import React from 'react';

const BigGreen = ({ label }) => {
    return (
        <div className='font-favela-bold mx-auto flex justify-center items-center bg-[#52FF00] uppercase text-black w-10/12 md:w-8/12 min-h-[60px] rounded-full'>
            {label}
        </div>
    );
};

export default BigGreen;
